import routes from './routes';

/*@ngInject*/
export default function config($routeProvider){
    routes($routeProvider);

}